;(function () {
  'use strict'

  angular
    .module('contrast.metric')
    .factory('metricService', metricServiceFactory)

  function metricServiceFactory() {
    'ngInject'

    var service = {
      getSizeShorthand: getSizeShorthand,
      getLocUnit: getLocUnit
    }

    return service

    function getSizeShorthand(value, precision) {
      if (value == 0) {
        return '0'
      }
      var k = 1000
      var sizes = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y']
      var i = Math.floor(Math.log(value) / Math.log(k))
      if (precision > 0) {
        return (value / Math.pow(k, i)).toPrecision(precision) + ' ' + sizes[i]
      } else {
        return Math.ceil(value / Math.pow(k, i)).toFixed(0) + ' ' + sizes[i]
      }
    }

    function getLocUnit(loc, precision) {
      if (isNaN(parseFloat(loc)) || !isFinite(loc)) {
        return '-'
      }
      if (typeof precision === 'undefined') {
        precision = 1
      }
      if (loc == 0) {
        return ''
      }
      var units = ['', 'K', 'M', 'B', 'T', 'Q'],
        number = Math.floor(Math.log(loc) / Math.log(1000))
      return units[number]
    }
  }
})()
